import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PillboxComponent } from './pillbox.component';
import { ButtonsModule } from '../buttons/buttons.module';

@NgModule({
  imports: [
    CommonModule,
    ButtonsModule
  ],
  declarations: [
    PillboxComponent
  ],
  exports: [
    PillboxComponent
  ]
})
export class PillboxModule { }
